import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Widget } from '@ispm/widgets/decorator/widget.decorator';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
import { FormGroup } from '@angular/forms';
import { find, findIndex, get, isEmpty, isEqual, set, without } from 'lodash';
import { map, switchMap } from 'rxjs/operators';
import { IoptionElemet } from '@ispm/shared/interfaces/IoptionElemet';
import { Observable } from 'rxjs/Observable';
import { SearchService } from '@ispm/dynamic-form/services/search.service';

@Component({
  selector: 'ispm-checkbox-valueset-list',
  templateUrl: './checkbox-valueset-list.component.html',
  styleUrls: ['./checkbox-valueset-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('CheckboxValueset')
export class CheckboxValuesetList implements OnInit, OnDestroy, IWidgetItem<any> {
  widgetUpdateValueCallback: (value) => void;
  private _widgetFormInstanceSubmitted: boolean;
  private data: Array<any> = [];
  private _backUpForm: any;
  public widgetConfigPayload;
  public widgetFormInstance: FormGroup;
  public itemName: string;
  public formData: any = { };
  public options$: Observable<IoptionElemet[] | any>;
  public suggestions: Array<any> = [];
  public excludeValues: Array<any> = [];
  public currentSelected: any;
  public _defaultList: Array<any> = [];
  public showAutoComplete: boolean = false;

  set widgetConfig(widgetConfig) {
    this.widgetConfigPayload = widgetConfig.widgetPayload;
    if (isEmpty(this._defaultList)) {
      this._defaultList = this.widgetConfigPayload.defaultList;
      this.excludeValues  = this._defaultList.map(obj => obj.code);
    }
    this.itemName = this.widgetConfigPayload.itemName;
  }



  set widgetData(widgetData: any) {
    if (widgetData != this.data && !Array.isArray(widgetData)) {
      this.data = [];
      this.formData = { };
      this._changeDetector.markForCheck();
      this._changeDetector.detectChanges();
    }
    if (Array.isArray(widgetData)) {
      this.data = widgetData;
      this.formData = this.processIntoForm(this.data);
      this._changeDetector.markForCheck();
      this._changeDetector.detectChanges();
    }
  }

  public get widgetFormInstanceSubmitted() {
    return this._widgetFormInstanceSubmitted;
  }

  public set widgetFormInstanceSubmitted(widgetFormInstanceSubmitted: boolean) {
    this._widgetFormInstanceSubmitted = widgetFormInstanceSubmitted;
  }


  constructor(private _changeDetector: ChangeDetectorRef,
              private _search: SearchService, ) {  }

  ngOnInit() { }


  updateTouched(event) {
    if (!(this.currentSelected)) {
      return;
    }
    let selected = this.currentSelected;

   // let selected =  find(this.suggestions, function(o) { return o.code === selectedCode; });
    // let selected = this.currentSelected;
     if (!(this.currentSelected.hasOwnProperty('code'))) {
       selected = { code: selected, display: selected};
     }
    const code = selected.code;
    const status = get(this.formData, this.itemName, []);
    status.pushIfNotExist(code, function(e) {
      return e  === selected.code;
    });
    const _defaultList = this._defaultList || [];
    _defaultList.pushIfNotExist(selected, function(e) {
      return e.code  === selected.code;
    });
    this._defaultList = _defaultList;
    const excludeList = this._defaultList.map(obj => obj.code);
    status.forEach((s) => {
      excludeList.pushIfNotExist(s, function(e) {
        return e  === s;
      });
    });
    this.excludeValues =  excludeList;
    if (this.getTheIndexOfItem(selected.code) !== 1) {
      this.data.push(Object.assign({ }, this.widgetConfigPayload.itemDefaultValue, { [this.itemName]: selected}));
    }
    this.showAutoComplete = false;
    this.currentSelected = null;
    this.formData =  set(this.formData, this.itemName, status);
    this.widgetUpdate(this.data);
  }

  onEnterEmitter($event) {
    if ($event.keyCode === 13) {
      this.updateTouched($event);
    }
  }

  search(event) {
    this.options$ = Observable.of({ })
      .pipe(
        switchMap(() => {
          return this._search.query(this.widgetConfigPayload.resource, event.query);
        }),
        map((elements: any[]) => {
               elements = elements.map(element => this._search.formalize(this.widgetConfigPayload.resource, element));
               return elements;
        }),
        map((elements: any[]) => {
          if (this.excludeValues) {
            elements = elements.filter(element => this.excludeValues.indexOf(element.code) === -1 );
          }
          this.suggestions = elements;
          return elements;
        })
      );
  }

  formChange(form) {
    const itemName = this.itemName;
    if (isEqual(this._backUpForm, form[itemName])) {
      return;
    }
    this._backUpForm = form[itemName];
    const items = form[itemName];
    const dataCodes =  this.data.map((p) => get(p, itemName + '.code'));
    const needsToAdd = without(items, ...dataCodes);
    const needsToDelete = without(dataCodes, ...items);


    needsToAdd.forEach((item) => {
      const selected =  find(this._defaultList, function(o) { return o.code === item; });
      const addItem = Object.assign({ }, this.widgetConfigPayload.itemDefaultValue, { [itemName]: selected});
      const pos = this.getTheIndexOfItem(item);
      if ( pos === -1) {
        this.data.push(addItem);
      } else {
       delete this.data[pos]['deleted'];
      }
    });

    needsToDelete.forEach((item) => {
      const index = this.getTheIndexOfItem(item);
      if (this.data[index].hasOwnProperty('id')) {
        this.data[index]['deleted'] = true;
      } else {
        this.data.splice(index, 1);
      }
    });
    this.formData[itemName] = items;
    this.widgetUpdate(this.data);
  }

  addClicked() {
    this.showAutoComplete = true;
  }

  isAddItemsAvailable() {
    return true;
  }

  private widgetUpdate(data) {
    // let backdata = cloneDeep(data);
      if (this.widgetUpdateValueCallback) {
      const dataWithDefault = [];
      data.forEach(item => {
        dataWithDefault.push(Object.assign(item, this.widgetConfigPayload.itemDefaultValue));
      });
      // TODO adding back the default values because formId is mandotory before saving in Pan dynamic modal
      this.widgetUpdateValueCallback.apply(this, [dataWithDefault]);
    }
  }

  processIntoForm(data: Array<any>) {
    const selectedCodes = [];
    data.forEach((s) => {
      const item = s[this.itemName];
      if (s['deleted']) {
        return;
      }
      if (item) {
        selectedCodes.pushIfNotExist(item.code, function (e) {
          return e.code === item.code;
        });
        this._defaultList.pushIfNotExist(item, function (e) {
          return e.code === item.code;
        });
      }
    });
    this.excludeValues = this._defaultList.map(obj => obj.code);
    const formData = { };
    formData[this.itemName] = selectedCodes;
    return formData;
    // Pick all the codes from the data objects assign to form data
  }



  getTheIndexOfItem(code: string): number {
    return findIndex(this.data, (e) => {
      const dataItem = e[this.itemName];
      return dataItem.code === code;
    });
  }


  public ngOnDestroy(): void {
    this._changeDetector.detach();
  }

}
